function customSelect($select) {
    const selectId = $select.attr('id');

    $select.wrap('<div class="input-wrapper ' + selectId + '"></div>');
    const $selectWrapper = $select.parent('.input-wrapper');

    const selectedOptionText = $select.find('option:selected').html();

    $selectWrapper.prepend('<div class="placeholder-wrapper"><span class="placeholder"><span class="text">' + selectedOptionText + '</span><i class="icon icon-arrow_down"></i></span></div>');

    $select.on('change', function(e) {
        const $target = $(e.target);
        const optionText = $target.find('option:selected').html();
        $target.parents('.input-wrapper').find('.placeholder-wrapper').find('.text').html(optionText);
    });
}

export default customSelect;
